export default __webpack_public_path__ + "static/media/sample-product.ad5fa38a.png";